import { isToolbarSaveActive } from './ToolbarStore';

export const updateToolbarSave = (value) => isToolbarSaveActive.update((oldValue) => value);
